import Link from 'next/link'
import Image from 'next/image'
import { useRouter } from 'next/router'
import { useAuth } from '../context/AuthContext'
import { useState, useEffect, useRef } from 'react'
import MyAccountView from './MyAccountView'
import MyCreditStatus from './MyCreditStatus'
import { createPortal } from 'react-dom'
import { useTheme } from '../context/ThemeContext'

// Base tabs that are always shown
const baseTabs = [
  { 
    name: 'Home', 
    path: '/',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
        <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z" />
      </svg>
    )
  },
  { 
    name: 'Voice Library', 
    path: '/voices',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
        <path fillRule="evenodd" d="M9.383 3.076A1 1 0 0110 4v12a1 1 0 01-1.707.707L4.586 13H2a1 1 0 01-1-1V8a1 1 0 011-1h2.586l3.707-3.707a1 1 0 011.09-.217zM14.657 2.929a1 1 0 011.414 0A9.972 9.972 0 0119 10a9.972 9.972 0 01-2.929 7.071 1 1 0 01-1.414-1.414A7.971 7.971 0 0017 10c0-2.21-.894-4.208-2.343-5.657a1 1 0 010-1.414zm-2.829 2.828a1 1 0 011.415 0A5.983 5.983 0 0115 10a5.984 5.984 0 01-1.757 4.243 1 1 0 01-1.415-1.415A3.984 3.984 0 0013 10a3.983 3.983 0 00-1.172-2.828 1 1 0 010-1.415z" clipRule="evenodd" />
      </svg>
    )
  },
  { type: 'divider', label: 'Products' },
  { 
    name: 'Text To Speech', 
    path: '/text-to-speech',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
        <path fillRule="evenodd" d="M7 4a3 3 0 016 0v4a3 3 0 11-6 0V4zm4 10.93A7.001 7.001 0 0017 8a1 1 0 10-2 0A5 5 0 015 8a1 1 0 00-2 0 7.001 7.001 0 006 6.93V17H6a1 1 0 100 2h8a1 1 0 100-2h-3v-2.07z" clipRule="evenodd" />
      </svg>
    )
  },
  { 
    name: 'Universal Translator', 
    path: '/translate',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
        <path fillRule="evenodd" d="M7 2a1 1 0 011 1v1h3a1 1 0 110 2H9.578a18.87 18.87 0 01-1.724 4.78c.29.354.596.696.914 1.026a1 1 0 11-1.44 1.389c-.188-.196-.373-.396-.554-.6a19.098 19.098 0 01-3.107 3.567 1 1 0 01-1.334-1.49 17.087 17.087 0 003.13-3.733 18.992 18.992 0 01-1.487-2.494 1 1 0 111.79-.89c.234.47.489.928.764 1.372.417-.934.752-1.913.997-2.927H3a1 1 0 110-2h3V3a1 1 0 011-1zm6 6a1 1 0 01.894.553l2.991 5.982a.869.869 0 01.02.037l.99 1.98a1 1 0 11-1.79.895L15.383 16h-4.764l-.724 1.447a1 1 0 11-1.788-.894l2.991-5.982A1 1 0 0113 8zm-1.382 6h2.764L13 12.236 11.618 14z" clipRule="evenodd" />
      </svg>
    )
  },
  { 
    name: 'Voice Cloning', 
    path: '/voice-cloning',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
        <path d="M8 5a1 1 0 100 2h5.586l-1.293 1.293a1 1 0 001.414 1.414l3-3a1 1 0 000-1.414l-3-3a1 1 0 10-1.414 1.414L13.586 5H8zM12 15a1 1 0 100-2H6.414l1.293-1.293a1 1 0 10-1.414-1.414l-3 3a1 1 0 000 1.414l3 3a1 1 0 001.414-1.414L6.414 15H12z" />
      </svg>
    )
  },
  { 
    name: 'Speech To Text', 
    path: '/speech-to-text',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
        <path fillRule="evenodd" d="M3 5a2 2 0 012-2h10a2 2 0 012 2v8a2 2 0 01-2 2h-2.22l.123.489.804.804A1 1 0 0113 18H7a1 1 0 01-.707-1.707l.804-.804L7.22 15H5a2 2 0 01-2-2V5zm5.771 7H5V5h10v7H8.771z" clipRule="evenodd" />
      </svg>
    )
  },
  { type: 'divider', label: 'Developers' },
  { 
    name: 'API Keys', 
    path: '/api-keys',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
        <path fillRule="evenodd" d="M18 8a6 6 0 01-7.743 5.743L10 14l-1 1-1 1H6v2H2v-4l4.257-4.257A6 6 0 1118 8zm-6-4a1 1 0 100 2 2 2 0 012 2 1 1 0 102 0 4 4 0 00-4-4z" clipRule="evenodd" />
      </svg>
    )
  },
]

export default function Sidebar() {
  const router = useRouter()
  const { username, isAuthenticated, logout, isStaff } = useAuth()
  const { theme } = useTheme()
  const [showAccountView, setShowAccountView] = useState(false)
  const [showDropdown, setShowDropdown] = useState(false)
  const dropdownRef = useRef(null)
  
  // Dynamic tabs based on user role
  const tabs = [...baseTabs]
  
  // Add Test Token for staff users
  if (isStaff) {
    const apiKeysIndex = tabs.findIndex(tab => tab.name === 'API Keys')
    if (apiKeysIndex !== -1) {
      tabs.splice(apiKeysIndex + 1, 0, {
        name: 'Test Token',
        path: '/test-token',
        icon: (
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
          </svg>
        )
      })
    }
  }
  
  // Desktop sidebar states
  const [isPinned, setIsPinned] = useState(true)
  const [isHovered, setIsHovered] = useState(false)
  const [previousPinState, setPreviousPinState] = useState(true)
  
  // Mobile sidebar states
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
  
  // Check if we're on mobile
  const [isMobile, setIsMobile] = useState(false)
  
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768) // md breakpoint
    }
    
    checkMobile()
    window.addEventListener('resize', checkMobile)
    return () => window.removeEventListener('resize', checkMobile)
  }, [])
  
  // Load pinned state from localStorage on mount
  useEffect(() => {
    const savedPinState = localStorage.getItem('sidebarPinned')
    if (savedPinState !== null) {
      setIsPinned(savedPinState === 'true')
      setPreviousPinState(savedPinState === 'true')
    }
  }, [])
  
  // Save pinned state to localStorage when it changes
  useEffect(() => {
    localStorage.setItem('sidebarPinned', isPinned.toString())
  }, [isPinned])
  
  // When account view is shown, ensure sidebar is pinned
  useEffect(() => {
    if (showAccountView) {
      setPreviousPinState(isPinned)
      setIsPinned(true)
    } else if (!showAccountView && isPinned !== previousPinState) {
      setIsPinned(previousPinState)
    }
  }, [showAccountView])
  
  // Ensure sidebar is pinned when user is authenticated (after login)
  useEffect(() => {
    if (isAuthenticated) {
      setIsPinned(true)
      localStorage.setItem('sidebarPinned', 'true')
    }
  }, [isAuthenticated])

  // Close mobile menu when route changes
  useEffect(() => {
    setIsMobileMenuOpen(false)
  }, [router.pathname])

  // State for credit data fetched by MyCreditStatus component
  const [creditData, setCreditData] = useState(null)

  // Handle clicking outside dropdown to close it
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false)
      }
    }

    if (showDropdown) {
      document.addEventListener('mousedown', handleClickOutside)
      return () => document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [showDropdown])

  // Mobile Header Component
  const MobileHeader = () => (
    <div className="md:hidden bg-white dark:bg-dark-card border-b border-gray-200 dark:border-dark-border px-4 py-3 flex items-center justify-between">
      {/* Mobile Logo */}
      <Link href="/" className="flex items-center">
        <Image 
          src="/favicon-32x32.png" 
          alt="CreoleCentric Logo" 
          width={32} 
          height={32} 
          className="mr-2"
        />
        <div className="text-xl font-bold text-blue-600 dark:text-blue-400">
          CreoleCentric
        </div>
      </Link>

      {/* Mobile Menu Button */}
      <button
        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        className="p-2 rounded-md text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
        aria-label="Toggle mobile menu"
      >
        {isMobileMenuOpen ? (
          <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        ) : (
          <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        )}
      </button>
    </div>
  )

  // Mobile Menu Overlay
  const MobileMenu = () => (
    <div className={`md:hidden fixed inset-0 z-50 transition-opacity duration-300 ${
      isMobileMenuOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
    }`}>
      {/* Backdrop */}
      <div 
        className="fixed inset-0 bg-black bg-opacity-50"
        onClick={() => setIsMobileMenuOpen(false)}
      />
      
      {/* Menu Panel */}
      <div className={`fixed top-0 left-0 h-full w-80 max-w-[85%] bg-white dark:bg-dark-card shadow-xl transform transition-transform duration-300 ${
        isMobileMenuOpen ? 'translate-x-0' : '-translate-x-full'
      }`}>
        {/* Mobile Menu Header */}
        <div className="p-4 border-b border-gray-200 dark:border-dark-border flex items-center justify-between">
          <div className="flex items-center">
            <Image 
              src="/favicon-32x32.png" 
              alt="CreoleCentric Logo" 
              width={32} 
              height={32} 
              className="mr-2"
            />
            <div className="text-xl font-bold text-blue-600 dark:text-blue-400">
              CreoleCentric
            </div>
          </div>
          <button
            onClick={() => setIsMobileMenuOpen(false)}
            className="p-2 rounded-md text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700"
            aria-label="Close menu"
          >
            <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Mobile Navigation */}
        <nav className="flex-1 overflow-y-auto py-4">
          {tabs.map((tab, index) => (
            tab.type === 'divider' ? (
              <div key={`divider-${index}`} className="py-2 mt-4 mb-2 px-4">
                <div className="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-2">{tab.label}</div>
                <div className="border-t border-gray-200 dark:border-dark-border"></div>
              </div>
            ) : tab.disabled ? (
              <div 
                key={tab.name}
                className="flex items-center px-4 py-3 text-gray-400 dark:text-gray-500 cursor-not-allowed"
              >
                <span className="mr-3">{tab.icon}</span>
                <span className="flex-1">{tab.name}</span>
                <span className="text-xs bg-gray-200 dark:bg-gray-700 px-2 py-1 rounded">Soon</span>
              </div>
            ) : (
              router.pathname === tab.path ? (
                <div 
                  key={tab.name}
                  className="flex items-center px-4 py-3 bg-blue-50 dark:bg-blue-900/20 border-r-2 border-blue-500 font-semibold text-blue-700 dark:text-blue-300"
                >
                  <span className="mr-3">{tab.icon}</span>
                  <span>{tab.name}</span>
                </div>
              ) : (
                <Link key={tab.name} href={tab.path}>
                  <a className="flex items-center px-4 py-3 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 active:bg-gray-100 dark:active:bg-gray-600 transition-colors">
                    <span className="mr-3">{tab.icon}</span>
                    <span>{tab.name}</span>
                  </a>
                </Link>
              )
            )
          ))}
        </nav>

        {/* Mobile Account Section */}
        <div className="border-t border-gray-200 dark:border-dark-border p-4">
          {isAuthenticated ? (
            <div>
              <div className="flex items-center mb-3">
                <MyCreditStatus 
                  showPercentage={false}
                />
                <div className="ml-3 flex-1">
                  <div className="font-medium text-gray-800 dark:text-gray-300">My Account</div>
                  <div className="text-sm text-gray-500 dark:text-gray-400">{username}</div>
                </div>
              </div>
              <button
                onClick={() => {
                  setShowAccountView(true)
                  setIsMobileMenuOpen(false)
                }}
                className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2 px-4 rounded-md text-sm font-medium transition-colors mb-2"
              >
                Account Settings
              </button>
              <button
                onClick={() => {
                  logout()
                  setIsMobileMenuOpen(false)
                }}
                className="w-full bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 text-gray-700 dark:text-gray-300 py-2 px-4 rounded-md text-sm font-medium transition-colors"
              >
                Sign Out
              </button>
            </div>
          ) : (
            <Link href="/login">
              <a
                onClick={() => setIsMobileMenuOpen(false)}
                className="block w-full bg-blue-600 hover:bg-blue-700 text-white py-2 px-4 rounded-md text-sm font-medium transition-colors text-center"
              >
                Sign In
              </a>
            </Link>
          )}
        </div>
      </div>
    </div>
  )

  // Desktop Sidebar (hidden on mobile)
  const DesktopSidebar = () => (
    <aside 
      className={`hidden md:flex bg-white dark:bg-dark-card border-r border-gray-200 dark:border-dark-border shadow-sm flex-col justify-between transition-all duration-300 relative ${
        isPinned || isHovered ? 'w-64' : 'w-16'
      }`}
      onMouseEnter={() => !showAccountView && setIsHovered(true)}
      onMouseLeave={() => !showAccountView && setIsHovered(false)}
    >
      <div>
        <div className={`p-6 flex items-center ${isPinned || isHovered ? 'justify-start' : 'justify-center'}`}>
          {/* Logo that's always visible */}
          <div className="flex items-center">
            <Image 
              src="/favicon-32x32.png" 
              alt="CreoleCentric Logo" 
              width={32} 
              height={32} 
              className={isPinned || isHovered ? 'mr-2' : ''}
            />
            <div className={`text-2xl font-bold text-blue-600 dark:text-blue-400 transition-opacity duration-300 ${
              isPinned || isHovered ? 'opacity-100' : 'opacity-0 w-0 overflow-hidden'
            }`}>
              CreoleCentric
            </div>
          </div>
        </div>
        
        {/* Floating toggle button */}
        <button 
          onClick={() => !showAccountView && setIsPinned(!isPinned)} 
          className={`absolute -right-3 top-8 w-6 h-6 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-full shadow-md flex items-center justify-center transition-all duration-300 hover:scale-110 ${
            showAccountView 
              ? 'text-gray-300 cursor-not-allowed' 
              : 'text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 cursor-pointer'
          } ${
            !isPinned && !isHovered ? 'opacity-0 pointer-events-none' : 'opacity-100'
          }`}
          title={showAccountView 
            ? "Pin/unpin disabled while account view is open" 
            : isPinned ? "Collapse sidebar" : "Expand sidebar"}
          disabled={showAccountView}
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3" viewBox="0 0 20 20" fill="currentColor">
            {isPinned ? (
              <path fillRule="evenodd" d="M9.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L6.414 10l3.293 3.293a1 1 0 010 1.414z" clipRule="evenodd" />
            ) : (
              <path fillRule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L13.586 10l-3.293-3.293a1 1 0 010-1.414z" clipRule="evenodd" />
            )}
          </svg>
        </button>
        <nav>
          {tabs.map((tab, index) => (
            tab.type === 'divider' ? (
              <div key={`divider-${index}`} className={`py-2 mt-2 mb-1 ${isPinned || isHovered ? 'px-6' : 'px-2'}`}>
                {(isPinned || isHovered) && <div className="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide">{tab.label}</div>}
                <div className="mt-1 border-t border-gray-200 dark:border-dark-border"></div>
              </div>
            ) : tab.disabled ? (
              <div 
                key={tab.name}
                className={`py-3 text-gray-400 dark:text-gray-500 cursor-not-allowed flex items-center ${
                  isPinned || isHovered ? 'px-6' : 'px-4 justify-center'
                }`}
                title={tab.name + " (Coming soon)"}
              >
                <span className={isPinned || isHovered ? "mr-3" : ""}>{tab.icon}</span>
                {(isPinned || isHovered) && (
                  <>
                    {tab.name}
                    <span className="ml-2 text-xs bg-gray-200 dark:bg-gray-700 px-2 py-0.5 rounded">Soon</span>
                  </>
                )}
              </div>
            ) : (
              router.pathname === tab.path ? (
                <div 
                  key={tab.name}
                  className={`py-3 cursor-pointer bg-gray-200 dark:bg-gray-700 font-semibold flex items-center ${
                    isPinned || isHovered ? 'px-6' : 'px-4 justify-center'
                  }`}
                  title={!isPinned && !isHovered ? tab.name : ""}
                >
                  <span className={isPinned || isHovered ? "mr-3 text-gray-600 dark:text-gray-300" : "text-gray-600 dark:text-gray-300"}>{tab.icon}</span>
                  {(isPinned || isHovered) && <span className="dark:text-gray-300">{tab.name}</span>}
                </div>
              ) : (
                <Link key={tab.name} href={tab.path} passHref scroll={router.pathname !== tab.path}>
                  <a 
                    className={`py-3 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-800 flex items-center ${
                      isPinned || isHovered ? 'px-6' : 'px-4 justify-center'
                    }`}
                    title={!isPinned && !isHovered ? tab.name : ""}
                  >
                    <span className={isPinned || isHovered ? "mr-3 text-gray-600 dark:text-gray-300" : "text-gray-600 dark:text-gray-300"}>{tab.icon}</span>
                    {(isPinned || isHovered) && <span className="dark:text-gray-300">{tab.name}</span>}
                  </a>
                </Link>
              )
            )
          ))}
        </nav>
      </div>
      <div className={`border-t dark:border-dark-border ${isPinned || isHovered ? 'p-6' : 'p-4'}`}>
        <div className={`flex items-center ${isPinned || isHovered ? 'justify-between' : 'justify-center'}`}>
          <div className="flex items-center">
            {isAuthenticated && <MyCreditStatus 
              showPercentage={false} 
            />}
            {(isPinned || isHovered) && (
              <div>
                <div className="font-medium text-gray-800 dark:text-gray-300">My Account</div>
                {isAuthenticated && <div className="text-xs text-gray-500 dark:text-gray-400">{username}</div>}
              </div>
            )}
          </div>
          {isAuthenticated && (isPinned || isHovered) ? (
            <button 
              onClick={() => setShowAccountView(!showAccountView)}
              className="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 focus:outline-none flex items-center justify-center"
              aria-label="Account options"
              data-account-button="true"
            >
              {showAccountView ? (
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z" clipRule="evenodd" />
                </svg>
              ) : (
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                </svg>
              )}
            </button>
          ) : (isPinned || isHovered) ? (
            <Link href="/login" passHref scroll={router.pathname !== '/login'}>
              <a className="text-sm text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300 cursor-pointer">
                Login
              </a>
            </Link>
          ) : null}
        </div>
      </div>
    </aside>
  )

  return (
    <>
      {/* Mobile Header and Menu */}
      <MobileHeader />
      <MobileMenu />
      
      {/* Desktop Sidebar */}
      <DesktopSidebar />
      
      {/* Render the account view if showAccountView is true */}
      {showAccountView && isAuthenticated && typeof window !== 'undefined' && createPortal(
        <MyAccountView 
          onClose={() => {
            setShowAccountView(false)
            // The useEffect will handle restoring the previous pin state
          }} 
          username={username}
        />,
        document.body
      )}
    </>
  )
}